import { t } from 'i18next';
import React, { FC } from 'react';

import Detail from '../components/Detail';
import { tryParseDate } from '../lib/date';
import emoji from '../lib/emoji';
import { EventResource } from '../models';

const DATE_FORMAT = {
  day: 'numeric',
  month: 'long',
};
const TIME_FORMAT = {
  hour: 'numeric',
  minute: 'numeric',
};
const DATETIME_FORMAT = {
  ...DATE_FORMAT,
  ...TIME_FORMAT,
};

const isSameDay = (date1: Date, date2: Date) =>
  date1.getDate() === date2.getDate() &&
  date1.getMonth() === date2.getMonth() &&
  date1.getFullYear() === date2.getFullYear();

const dateString = (date1: Date, date2?: Date) => {
  const includeYear = date1.getFullYear() !== new Date().getFullYear();
  const dateTimeFormat = includeYear ? { ...DATETIME_FORMAT, year: 'numeric' } : DATETIME_FORMAT;
  const dateFormat = includeYear ? { ...DATE_FORMAT, year: 'numeric' } : DATE_FORMAT;

  if (!date2) {
    return t('glapp.startDate.single', {
      date: date1,
      formatParams: {
        date: dateTimeFormat,
      },
    });
  }

  if (isSameDay(date1, date2)) {
    return t('glapp.startDate.sameDay', {
      date1,
      date2,
      formatParams: {
        date1: dateTimeFormat,
        date2: TIME_FORMAT,
      },
    });
  }

  return t('glapp.startDate.range', {
    date1,
    date2,
    formatParams: {
      date1: dateFormat,
      date2: dateFormat,
    },
  });
};

const StartDateDetail: FC<{ event: EventResource }> = ({ event }) => {
  const startDate = tryParseDate(event.attributes.happensAt);
  const endDate = tryParseDate(event.attributes.endsAt);

  if (!startDate) {
    return null;
  }

  return <Detail text={emoji(`📅 ${dateString(startDate, endDate)}`)} />;
};

export default StartDateDetail;
